import { Button } from 'components';
import { FileXls } from '@phosphor-icons/react';
import { t } from '@lingui/macro';
import { Text } from 'components/text';

export interface TableExportButtonProps {
  onClick: () => void;
  isLoading?: boolean;
  disabled?: boolean;
}

export const TableExportButton = ({
  onClick,
  isLoading = false,
  disabled = false,
}: TableExportButtonProps) => {
  return (
    <Button
      startIcon={<FileXls color="#666666" size={16} />}
      variant="tertiary"
      size="md"
      onClick={onClick}
      disabled={disabled || isLoading}
      sx={{
        width: '100%',
        justifyContent: 'flex-start',
      }}
    >
      <Text variant="bodySm" weight="semiBold" color="secondary">
        {isLoading ? t`Exporting...` : t`Export`}
      </Text>
    </Button>
  );
};
